import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, MapPin, Phone, Mail, MessageCircle, ChefHat } from 'lucide-react';
import styles from './Footer.module.css';

function Footer() {
  const navigate = useNavigate();

  const handleBlogClick = (path) => {
    // Navigate to the blog post
    navigate(path);
    // Scroll to top after navigation
    window.scrollTo(0, 0);
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.glow}></div>
      
      <div className={styles.content}>
        <div className={styles.section}>
          <h3 className={styles.title}>About Us</h3>
          <p className={styles.description}>
            Folsom Microgreens is a local business dedicated to providing fresh, nutritious microgreens 
            to restaurants and food businesses. Our passion is growing vibrant, healthy greens for your culinary needs!
          </p>
          <div className={styles.social}>
            <a 
              href="https://instagram.com/folsommicrogreens" 
              target="_blank" 
              rel="noopener noreferrer"
              className={`${styles.socialLink} ${styles.instagramLink}`}
            >
              <Instagram className={styles.socialIcon} />
              <span>Follow us</span>
            </a>
            <a 
              href="https://wa.me/12798427951" 
              target="_blank" 
              rel="noopener noreferrer"
              className={`${styles.socialLink} ${styles.whatsappLink}`}
            >
              <MessageCircle className={styles.socialIcon} />
              <span>Chat with us</span>
            </a>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.title}>Get In Touch</h3>
          <div className={styles.contactGrid}>
            <a 
              href="mailto:contact@folsommicrogreens.com" 
              className={`${styles.contactItem} ${styles.emailLink}`}
            >
              <Mail className={styles.icon} />
              <div>
                <span>contact@folsommicrogreens.com</span>
              </div>
            </a>
            <a
              href="tel:+12798427951"
              className={`${styles.contactItem} ${styles.phoneLink}`}
            >
              <Phone className={styles.icon} />
              <div>
                <span>279-842-7951</span>
              </div>
            </a>
            <a
              href="mailto:contact@folsommicrogreens.com?subject=Restaurant%20inquiry"
              className={`${styles.contactItem} ${styles.emailLink}`}
            >
              <ChefHat className={styles.icon} />
              <div>
                <span>Chef inquiries — free samples on request</span>
              </div>
            </a>
            <div className={styles.contactItem}>
              <MapPin className={styles.icon} />
              <div>
                <span>Folsom, California</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h3 className={styles.title}>Latest Articles</h3>
          <ul className={styles.articleList}>
            <li>
              <button 
                onClick={() => handleBlogClick('/blog/why-microgreens')}
                className={styles.articleLink}
              >
                Why Microgreens?
              </button>
            </li>
            <li>
              <button 
                onClick={() => handleBlogClick('/blog/early-growth-stages')}
                className={styles.articleLink}
              >
                Discover the Early Growth Stages of a Plant
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.watermark}>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-icon.png`}
            alt="Folsom Microgreens"
            className={styles.logo}
          />
          <p>Consider eating Microgreens, you will thank us later</p>
        </div>
        <p className={styles.copyright}>&copy; 2026 Folsom Microgreens. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;